<template>
  <section>
    <v-card>
      <v-card-subtitle v-if="$slots.title" class="pa-1">
        <slot name="title"></slot>
      </v-card-subtitle>
      <v-list dropzone>
        <v-list-item
          draggable
          v-for="(item, i) in tmpList"
          :key="item + '-' + i"
          :class="{
            listItemDrag: true,
            dragItem: true,
            dragged: i === dragged,
            over: i === overCurrent && i !== dragged,
          }"
          @dragstart="drag(i)"
          @dragover="over(i)"
          @dragend="drop(item)"
        >
          <v-list-item-icon class="mx-2">
            <slot v-if="$slots.icon" name="icon"></slot>
            <v-icon v-else>mdi-{{ item.icon || icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>
            {{ item.text }} <small v-if="values">({{ item.value }})</small>
          </v-list-item-title>
          <Tooltip content="Drag & Drop Item" top>
            <v-list-item-icon class="mx-2" v-if="i !== dragged">
              <v-icon small>mdi-arrow-up-down</v-icon>
            </v-list-item-icon>
          </Tooltip>
          <Tooltip content="Delete Item" left color="error">
            <v-list-item-icon class="mx-2" v-if="i !== dragged && removable">
              <v-icon class="pointer" small @click="remove(i)" color="error">
                mdi-delete-empty
              </v-icon>
            </v-list-item-icon>
          </Tooltip>
        </v-list-item>
        <v-list-item v-if="!tmpList.length">
          <v-icon small class="mx-1">mdi-cancel</v-icon> List is empty
        </v-list-item>
      </v-list>
    </v-card>
  </section>
</template>

<script lang="ts">
import { SelectItem } from "@/types";
import Vue from "vue";
import VueTypes from "vue-types";
import Tooltip from "@/components/Tooltip.vue";

export default Vue.extend({
  name: "DragList",
  data() {
    return {
      dragged: null as SelectItem,
      overCurrent: null as SelectItem,
    };
  },
  props: {
    list: VueTypes.any.def([]),
    values: VueTypes.bool.def(false),
    removable: VueTypes.bool.def(false),
    icon: VueTypes.string.def("drag-horizontal"),
    callback: VueTypes.any,
  },
  methods: {
    updateList() {
      this.$emit("changed", this.tmpList);
    },
    drag(i: number) {
      this.dragged = i;
    },
    remove(i: number) {
      this.tmpList.splice(i, 1);
      this.updateList();
    },
    over(i: number) {
      if (i !== this.overCurrent) {
        this.overCurrent = i;
      }
    },
    drop(item: never) {
      this.tmpList.splice(this.dragged, 1);
      this.tmpList.splice(this.overCurrent, 0, item);
      this.overCurrent = null;
      this.dragged = null;
      this.updateList();
    },
  },
  computed: {
    tmpList: {
      get():SelectItem[] {
        return this.list;
      },
      set(list: SelectItem[]) {
        this.$emit("changed", list);
      },
    },
  },
  components: { Tooltip },
});
</script>
<style>
.listItemDrag {
  cursor: move;
}
.dragged {
  opacity: 0.2 !important;
}
.over {
  background-color: rgba(204, 204, 204, 0.308) !important;
}
/* .dragItem::before{
  height: 20px;
  width: 100%;
  display: block;
  background-color: red;
} */
</style>
